<template>
    <div id="manager-data">
        <v-data-table :headers="headers" :items="data" sort-by="user.cn">
            <template v-slot:item.actions="{ item }">
                <edit-user :buildings="buildings" :item="item" @refreshData="refreshData"
                    @setNotification="setNotification"></edit-user>
                <delete-user :item="item" @refreshData="refreshData" @setNotification="setNotification"></delete-user>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item)" small>
                    {{ getStatusLabel(item) }}
                </v-chip>
            </template>
            <template v-slot:item.type="{ item }">
                <span class="ra__type">
                    {{ getResidenceAsistantType(item) }}
                </span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import DeleteUser from './DeleteUser';
import EditUser from './EditUser';

export default {
    name: 'residence-assistant-manager-data',
    components: {
        DeleteUser,
        EditUser
    },
    props: {
        buildings: {
            required: true,
            type: Array
        },
        data: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            headers: [{
                    text: 'Name',
                    align: 'start',
                    value: 'cn',
                },
                {
                    text: 'Username',
                    value: 'username',
                },
                {
                    text: 'Mail',
                    value: 'mail',
                },
                {
                    text: 'Gender',
                    value: 'gender',
                },
                {
                    text: 'Type',
                    value: 'type',
                },
                {
                    text: 'Start Date',
                    value: 'startDate',
                },
                {
                    text: 'End Date',
                    value: 'endDate',
                },
                {
                    sortable: false,
                    text: 'Status',
                    value: 'status',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ]
        }
    },
    methods: {
        getResidenceAsistantType(item) {
            return item.ratype || 'N/A';
        },
        getStatusColor(item) {
            /* eslint-disable no-useless-escape */
            let currentDate = new Date().toISOString().slice(0, 10).replace(/\-/g, "");
            let enddate = item.endDate.replace(/\-/g, "");
            let startdate = item.startDate.replace(/\-/g, "");

            if (item.active == '1' || (currentDate >= startdate && currentDate <= enddate)) {
                return '#1dc9b7';
            }

            return '#ffb822';
        },
        getStatusLabel(item) {
            /* eslint-disable no-useless-escape */
            let currentDate = new Date().toISOString().slice(0, 10).replace(/\-/g, "");
            let enddate = item.endDate.replace(/\-/g, "");
            let startdate = item.startDate.replace(/\-/g, "");

            if (item.active == '1' || (currentDate >= startdate && currentDate <= enddate)) {
                return 'Active';
            }

            return 'Inactive'
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.ra__type {
    text-transform: capitalize;
}
</style>